import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Deep Link Layout Route
 *
 * This pathless layout wraps all routes that serve as direct access/shareable entry points
 * for specific ThoughtSpot content. Users typically land here via:
 * - Shared links (email, Slack, etc.)
 * - Bookmarks
 * - External integrations
 *
 * Routes in this layout:
 * - /dashboard/charts/{id} - Direct link to specific chart
 * - /dashboard/pinboard/{id} - Direct link to specific dashboard/liveboard
 * - /dashboard/ai-highlight/{id} - Direct link to specific AI highlight
 * - /dashboard/insight/{id} - Redirect to ai-highlight (handles broken ThoughtSpot AI highlight email links)
 * - /dashboard/search/{guid} - Direct link to search with data source
 * - /dashboard/user-preference - Link to ThoughtSpot notification preferences
 * - /dashboard/unsubscribe - Redirect to /dashboard/user-preference
 *
 * This layout provides a centralized place to add deep link specific features:
 * - Analytics tracking (referrer, share source)
 * - Loading states optimized for cold starts
 * - Error boundaries for invalid IDs
 * - Breadcrumb generation for "Back to..." navigation
 */
export const Route = createFileRoute('/dashboard/_deep-links')({
  component: DeepLinkLayout,
});

function DeepLinkLayout() {
  return <Outlet />;
}
